import update from "immutability-helper";

import {
  CLIPS_LOADING,
  CLIPS_LOADED,
  CLIPS_SET_PAGE_VIEW,
  CLIPS_RESET_CURRENT,
  CLIPS_SORT_SETTING,
} from "../actions/types";
import type { Clip } from "../state/story_authoring/reducer";

export interface SortOptions {
  column: null | string;
  order: "asc" | "desc";
  title: null | string;
}
export interface ClipsState {
  isLoadingClips: boolean;
  clips: Clip[];
  searchParam: string;
  sort: SortOptions;
  paging: {
    size: number;
    current: number;
    count: number;
    totalItems: number;
  };
}

const initialState: ClipsState = {
  isLoadingClips: false,
  clips: [],
  searchParam: "",
  sort: {
    column: "creationDate",
    order: "desc",
    title: "newest",
  },
  paging: {
    size: 15,
    current: 1,
    count: 1,
    totalItems: 0,
  },
};

const clipsReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case CLIPS_LOADING: {
      return update(state, { isLoadingClips: { $set: true } });
    }
    case CLIPS_LOADED: {
      return update(state, {
        clips: { $set: payload.clips },
        isLoadingClips: { $set: false },
        paging: {
          totalItems: { $set: payload.total },
          current: { $set: payload.page },
          count: { $set: Math.ceil(payload.total / state.paging.size) },
        },
      });
    }
    case CLIPS_SET_PAGE_VIEW: {
      const { currentPage, pageSize } = payload;
      return update(
        state,
        pageSize != null
          ? {
              paging: {
                size: { $set: pageSize },
                current: { $set: currentPage != null ? currentPage : 1 },
              },
            }
          : currentPage == null
          ? {}
          : { paging: { current: { $set: currentPage } } }
      );
    }
    case CLIPS_SORT_SETTING: {
      const { column, order, title } = payload;
      return update(state, {
        sort: {
          column: { $set: column },
          order: { $set: order },
          title: { $set: title },
        },
      });
    }
    case CLIPS_RESET_CURRENT: {
      return update(state, {
        clips: { $set: initialState.clips },
        paging: {
          current: { $set: initialState.paging.current },
          count: { $set: initialState.paging.count },
          totalItems: { $set: initialState.paging.totalItems },
        },
      });
    }
    default:
      return state;
  }
};

export default clipsReducer;
